var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuperAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 23,
    viewBox: "0 0 36 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4993 10.3694C34.0345 6.60285 28.0719 1.76528 26.3834 0.85463L25.0643 0.142782L24.3509 1.46173C23.4728 3.08851 22.6138 4.65329 21.7484 6.14112C21.2342 5.53725 20.6837 4.96612 20.1 4.43097L20.0831 4.41814C13.6837 -1.31939 7.59866 -0.663124 4.038 1.86362C0.549098 4.33905 -0.884031 8.65075 0.55332 12.3468C2.08143 16.2695 8.38804 21.5281 9.48558 22.3319L10.2728 22.9091L11.1171 22.4196C17.9134 18.4734 21.9278 12.1886 26.2019 4.37753C28.2999 5.97651 31.8331 9.23862 32.7069 11.4853C33.5512 13.6743 32.4473 16.5324 30.0644 18.281C28.8444 19.1767 24.5007 21.7013 18.9603 17.3191C18.2617 18.0612 17.5262 18.7668 16.7568 19.4332C22.5948 24.2644 28.3653 23.281 31.8268 20.7479C35.3579 18.1549 36.8691 13.8945 35.4993 10.3694ZM10.4755 19.2558C8.41126 17.5456 4.29339 13.6529 3.34993 11.2309C2.42335 8.84956 3.41536 6.02141 5.7624 4.35615C7.03575 3.48108 8.54203 3.01953 10.0808 3.03293C12.1914 3.03293 14.9247 3.85593 18.0844 6.68409C18.8215 7.35586 19.4866 8.10465 20.0684 8.91796C17.3435 13.2126 14.4055 16.744 10.4755 19.2558Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuperAdmin);
export default __webpack_public_path__ + "static/media/icon_super-admin.c44fc55888ddcee46a8408859f02a1ad.svg";
export { ForwardRef as ReactComponent };